<template>
    <div>
        <div>Hello World</div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "WarehouseDashboard",
    data: () => ({}),
    methods: {},
    onMounted() {
        console.log("Dashboard mounted");
    },
});

</script>
